import { render, staticRenderFns } from "./ModalLoader.vue?vue&type=template&id=324ffe33&"
import script from "./ModalLoader.vue?vue&type=script&lang=js&"
export * from "./ModalLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports